import React from "react";

import { Box, CircularProgress, ImageList, ImageListItem, Divider, Typography } from "@mui/material";
import { Image } from "@mui/icons-material";
import { useGetManageWeddingInvitationAnimeQuery } from "../../../store/services/invitations/invitations.service";
import { ImageSelectorWrapper } from "./styles";
import { IAnime } from "../../../store/services/invitations/dto/invitations.dto";

const ImageSelector = ({
	fieldValueState: imageSrc,
	setFieldValueState
}: {
	fieldValueState: IAnime;
	setFieldValueState: React.Dispatch<React.SetStateAction<IAnime>>;
}) => {
	const { data, isLoading } = useGetManageWeddingInvitationAnimeQuery();
	return (
		<ImageSelectorWrapper p={1}>
			{isLoading ? (
				<CircularProgress />
			) : (
				<>
					{imageSrc ? (
						<Box display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"}>
							<img src={imageSrc.main_image} alt="Uploaded" className={"image_view"} />
						</Box>
					) : (
						<Box my={3}>
							<Box my={1} display={"flex"} flexDirection={"column"} alignItems={"center"} className={"border-dashed"}>
								{!imageSrc && <Image />}
								<Typography textAlign={"center"}>Select an image from the below list</Typography>
							</Box>
						</Box>
					)}
					<Box my={3}>
						<Divider />
					</Box>
					<Box className={"image_list_wrapper"}>
						<ImageList variant="masonry" cols={2} gap={20}>
							{data ? (
								data.map(item => (
									<ImageListItem
										key={item.id}
										onClick={() => setFieldValueState(item)}
										style={{ cursor: "pointer" }}
										className={`${item.id === imageSrc.id ? "selected" : ""}`}
									>
										<img srcSet={`${item.main_image}`} src={`${item.main_image}`} alt={"Animation"} loading="lazy" />
									</ImageListItem>
								))
							) : (
								<></>
							)}
						</ImageList>
					</Box>
				</>
			)}
		</ImageSelectorWrapper>
	);
};

export default ImageSelector;
